import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CaseStudyCardProps {
  title: string;
  category: string;
  description: string;
  imageColor: string;
  tags: string[];
}
export function CaseStudyCard({
  title,
  category,
  description,
  imageColor,
  tags
}: CaseStudyCardProps) {
  return <article className="group cursor-pointer flex flex-col gap-6" data-id="element-25">
      {/* Image Placeholder */}
      <div className="w-full aspect-[4/3] rounded-xl overflow-hidden relative transition-all duration-500 group-hover:-translate-y-2 group-hover:shadow-2xl" style={{
      backgroundColor: imageColor
    }} data-id="element-26">
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-black to-transparent mix-blend-overlay" data-id="element-27"></div>

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300 flex items-center justify-center" data-id="element-28">
          <div className="opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 bg-bg text-text px-6 py-3 rounded-full font-medium text-sm flex items-center gap-2 shadow-lg" data-id="element-29">
            View Case Study <ArrowRight size={16} data-id="element-30" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-3" data-id="element-31">
        <div className="flex items-center gap-3" data-id="element-32">
          <span className="text-xs font-bold uppercase tracking-wider text-accent" data-id="element-33">
            {category}
          </span>
          <span className="w-8 h-[1px] bg-border" data-id="element-34"></span>
        </div>

        <h3 className="font-serif text-2xl md:text-3xl text-text group-hover:text-accent transition-colors duration-300" data-id="element-35">
          {title}
        </h3>

        <p className="font-sans text-text-muted leading-relaxed line-clamp-2" data-id="element-36">
          {description}
        </p>

        <div className="flex flex-wrap gap-2 mt-2" data-id="element-37">
          {tags.map(tag => <span key={tag} className="text-xs font-medium px-3 py-1 rounded-full bg-card-bg text-text-muted border border-border" data-id="element-38">
              {tag}
            </span>)}
        </div>
      </div>
    </article>;
}